import PropTypes from 'prop-types';

export const destinationPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    url: PropTypes.string,
});

export const localFilePropType = PropTypes.shape({
    name: PropTypes.string,
});

export const sitePropType = PropTypes.shape({
    _local_ios_push_certificate_file: localFilePropType,
    _local_ios_universal_link_subdomain: PropTypes.string,
    _published: PropTypes.bool,
    admon_revenue_source: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string })]),
    admon_revenue_source_read_only: PropTypes.bool,
    admon_revenue_sources: PropTypes.arrayOf(PropTypes.string),
    admon_revenue_upcoming_source: PropTypes.shape({
        admon_source: PropTypes.string,
        start_date: PropTypes.string,
    }),
    allow_show_advanced_settings: PropTypes.bool,
    app_scheme: PropTypes.string,
    app_signing_certificate: PropTypes.string,
    destinations: PropTypes.shape({
        deeplink: PropTypes.arrayOf(destinationPropType),
        ios_universal_link: PropTypes.arrayOf(destinationPropType),
        regular: PropTypes.arrayOf(destinationPropType),
    }),
    fcmIntegrationMessage: PropTypes.string,
    fcmIntegrationStatus: PropTypes.bool,
    fcm_project_id: PropTypes.string,
    fcm_server_key: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inactivity_window_h: PropTypes.number,
    initial_inactivity_window: PropTypes.number,
    initial_session_dedup_window: PropTypes.number,
    ios_push_certificate_p12_key: PropTypes.string,
    ios_universal_link_subdomain: PropTypes.string,
    ios_universal_link_team_id: PropTypes.string,
    isTestingFcmIntegration: PropTypes.bool,
    is_app_clip: PropTypes.bool,
    lds_default: PropTypes.bool,
    longname: PropTypes.string,
    new_admon_dialog_open: PropTypes.bool,
    new_admon_revenue_source: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string })]),
    new_admon_revenue_start_date: PropTypes.string,
    platform: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string })]),
    sdk_integrated: PropTypes.bool,
    session_dedup_window: PropTypes.number,
    show_advanced_settings: PropTypes.bool,
    site_public_id: PropTypes.string,
});

export const validationErrorsPropType = PropTypes.shape({
    _local_ios_push_certificate_file: PropTypes.string,
    fcm_project_id: PropTypes.string,
    fcm_server_key: PropTypes.string,
    ios_push_certificate_p12_key: PropTypes.string,
    ios_universal_link_subdomain: PropTypes.string,
    session_dedup_window: PropTypes.string,
});

export const admonSourceListPropType = PropTypes.arrayOf(PropTypes.shape({}));
